import { RFQState } from './types'

// Shared store to temporarily hold RFQ state during navigation
// This is needed because React Router state can't serialize complex objects like Workbook/CsvSheet
const rfqStateStore = new Map<string, RFQState>()

export const setRfqState = (key: string, state: RFQState): void => {
    rfqStateStore.set(key, state)
    // Clean up after 5 minutes to prevent memory leaks
    setTimeout(
        () => {
            rfqStateStore.delete(key)
        },
        5 * 60 * 1000,
    )
}

export const getRfqState = (key: string): RFQState | undefined => {
    const state = rfqStateStore.get(key)
    if (state) {
        // Clean up after retrieving
        rfqStateStore.delete(key)
        return state
    }
    return undefined
}
